





















































import {
  defineComponent,
  ref,
  watch,
  computed,
  onMounted,
} from '@vue/composition-api';
import FormField from '@/components/form-field';
import type {
} from '@/api/apply-product/types';
import { Toast } from '@hb/coffee';
import store from '@/store';
import { ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';

export default defineComponent({
  name: 'MarketingAmount',
  components: {
    FormField,
  },
  setup() {
    const marketingAmount = ref(0);
    const channel = computed(() => store.state.applyProduct.channel);
    const couponList = computed(() => store.state.applyProduct.couponList);
    const productName = computed(() => channel.value?.productName);
    /** 是否展示优惠模块优化实验 */
    const isDiscountModuleExperiment = computed(
      () => store.getters['applyProduct/isDiscountModuleExperiment'],
    );

    /** 是否有优惠券模块 */
    const hasCouponModule = computed(() => store.getters['applyProduct/showCouponModule']);

    /** 营销系数 */
    const marketingCoefficient = computed(
      () => store.state.applyProduct.marketingAmount.marketingCoefficient,
    );

    /**
     * 初始化计算营销潜力额度，潜力额度 = 授信额度 * 营销系数
     * 展示条件：
     * 1. 渠道支持营销额度
     * 2. 营销系数 > 0（即命中实验组）
     * PRD：https://hellobike.yuque.com/yxr77w/mniaoo/ldmrzwgryiyful6u
    */
    const init = () => {
      if (channel.value) {
        const { availableAmount, supportMarketingAmount } = channel.value;
        if (supportMarketingAmount
          && marketingCoefficient.value
          && marketingCoefficient.value > 0
        ) {
          // 额度向下取整，避免存在小数计算精度问题
          const calcMarketingAmount = Math.floor(
            Number(availableAmount) * marketingCoefficient.value,
          );
          marketingAmount.value = calcMarketingAmount > 200000 ? 200000 : calcMarketingAmount;
        } else {
          marketingAmount.value = 0;
        }
      }
    };

    /** 展示额度提示 */
    const detailTip = () => {
      Toast('提现并按时还，最高可提升至潜力额度');
      ubtSetupPageButton('finance_loan_apply_marketingAmount_detailTip', {
        type: isDiscountModuleExperiment.value ? 'discountModuleExperiment' : 'marketingAmountExperiment',
      });
    };

    /** 初始化以及监听渠道变化，计算营销潜力额度 */
    onMounted(() => {
      init();
    });

    watch(
      () => channel.value,
      () => {
        init();
      },
    );

    return {
      marketingAmount,
      hasCouponModule,
      detailTip,
      productName,
      isDiscountModuleExperiment,
    };
  },
});
